import React from 'react';

interface ChatLayoutProps {
  children: React.ReactNode;
}

const chatLayoutContainerStyle: React.CSSProperties = {
  display: 'flex',
  height: '100vh',
  width: '100vw',
  overflow: 'hidden',
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: '#0C1319', // Primary dark background
};

/**
 * ChatLayout - A full-screen layout specifically for the chat page
 * Bypasses the global header and provides a dedicated chat layout
 */
const ChatLayout: React.FC<ChatLayoutProps> = ({ children }) => {
  return (
    <div style={chatLayoutContainerStyle}>
      {children}
    </div>
  );
};

export default ChatLayout;
